export default {"src":"/_next/static/media/box.f531b498.svg","height":185,"width":367};